module.exports = __webpack_public_path__ + "img/zkm-logo.21569f31.svg";